import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import ErrorBoundary from 'components/Common/ErrorBoundary';

// App components
import SuspenseLoader from 'components/Common/SuspenseLoader';
// import MilestonePublic from 'pages/MilestonePublic';

// Pages
const Home = lazy(() => import('../pages/Home'));
const Login = lazy(() => import('../pages/Login'));
const ForgotPassword = lazy(() => import('pages/ForgotPassword'));
const PasswordReset = lazy(() => import('pages/PasswordReset'));
const Pager = lazy(() => import('components/Pager'));
// const MilestonePublic = lazy(() => import('pages/MilestonePublic'));
const PublicForm = lazy(() => import('pages/PublicForm'));
const PublicFormReview = lazy(() => import('pages/PublicForm/views/Review'));
const PublicFormSuccess = lazy(() => import('pages/PublicForm/views/Success'));
const PublicFormV2 = lazy(() => import('pages/PublicFormV2'));
const PublicFormV2Review = lazy(() => import('pages/PublicFormV2/Review'));
const PublicFormV2Success = lazy(() => import('pages/PublicFormV2/Success'));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<SuspenseLoader />}>
        <Switch>
          <Route exact path="/login">
            <ErrorBoundary>
              <Pager content={<Login />} title="Login" />
            </ErrorBoundary>
          </Route>
          {/* <Route
            exact
            path="/projects/:partnerId/concept/:conceptId/public/milestone"
            component={MilestonePublic}
          />
          <Route
            exact
            path="/projects/:partnerId/concept/:conceptId/public/milestone/campaign"
            component={MilestonePublic}
          /> */}
          {/* A bare /form opens the V2 form. Links that carry parameters (e.g.
              editing a brief with `brief_id`) still open the original form.
              Redirecting before AuthenticatedRoutes mounts keeps its route
              guard from pushing /form back. */}
          <Route
            exact
            path="/form"
            render={({ location }) =>
              new URLSearchParams(location.search).toString() ? (
                <AuthenticatedRoutes component={PublicForm} />
              ) : (
                <Redirect to="/formv2" />
              )
            }
          />
          <AuthenticatedRoutes exact path="/formv2" component={PublicFormV2} />
          <AuthenticatedRoutes
            exact
            path="/formv2/review"
            component={PublicFormV2Review}
          />
          <AuthenticatedRoutes
            exact
            path="/formv2/success"
            component={PublicFormV2Success}
          />
          <AuthenticatedRoutes
            exact
            path="/form/review"
            component={PublicFormReview}
          />
          <AuthenticatedRoutes
            exact
            path="/form/success"
            component={PublicFormSuccess}
          />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/password-reset/:key" component={PasswordReset} />

          <AuthenticatedRoutes component={Home} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default App;
